import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IBulkUpdateOrdersStatusRepoResponse = IRepoResponse<200> | IRepoResponse<400 | 500, string>;

export type IBulkUpdateOrdersStatusRepo = IRepo<[object, { statusId: number | string; description?: string }], IBulkUpdateOrdersStatusRepoResponse>;

export const BulkUpdateOrdersStatusRepoType = Symbol.for('BulkUpdateOrdersStatusRepo');

@bind(BulkUpdateOrdersStatusRepoType)
export class BulkUpdateOrdersStatusRepo implements IBulkUpdateOrdersStatusRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object, { statusId, description }) {
    try {
      const result = await this.httpClient.post({ url: urlMaker('/api/admin/v2/orders/edit/state', { ...query, new_state_id: statusId, new_client_descr: description }) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400 || result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
